// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1P2ff","buttons":"RemoveExpirationActionButtons_buttons__TQ5D4"};